<template>
    <router-link class="logo" to="/">
        <the-logo />
    </router-link>
</template>

<script>
import TheLogo from "@/components/TheLogo";

export default {
    components: { TheLogo }
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media

.logo
    height: calc(var(--line-base) * 2.5)
    transition: opacity var(--speed-fast) var(--motion-out), transform var(--speed-fast) var(--motion-out)
    padding-left: var(--line-base)

    svg
        height: calc(var(--line-base) * 2)
        width: calc(var(--line-base) * 2)

.scrolled

    .logo
        opacity: 0
        transform: translateY(calc(var(--line-base) * -0.25))
        transition-timing-function: var(--motion-sharp), var(--motion-sharp)
</style>
